import Account from '@/components/account/Account';

export default function account() {
  return <Account />;
}
